import React, { useEffect } from 'react';
import './Services.css';

export default function Services(){
  useEffect(()=>{
    const observer = new IntersectionObserver((entries)=>{
      entries.forEach(e=>{ if(e.isIntersecting){ e.target.classList.add('visible'); observer.unobserve(e.target) }})
    },{threshold:.1});
    document.querySelectorAll('.scroll-reveal').forEach(el=>observer.observe(el));
    return ()=>observer.disconnect();
  },[]);

  return (
    <section className="page bg-light">
      <div className="page-min-bg" aria-hidden="true">
        <svg className="bg-lines" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
          <path d="M -50 200 Q 100 100, 300 50" className="bg-arc" />
          <path d="M 700 -50 Q 850 100, 1000 300" className="bg-arc" />
          <path d="M 400 300 Q 600 250, 800 300" className="bg-arc center" />
        </svg>
        <div className="blob blob-1" />
        <div className="blob blob-2" />
        <div className="blob blob-3" />
        <div className="ring ring-1" />
        <div className="dots">
          <span className="dot dot-1" />
          <span className="dot dot-2" />
          <span className="dot dot-3" />
          <span className="dot dot-4" />
          <span className="dot dot-5" />
        </div>
      </div>
      <div className="container">
        <div className="text-center mb-5 scroll-reveal">
          {/* <div className="fw-bold text-center">Services</div> */}
        
          <h2 className="fw-bold mb-3">Our Specialized <span className="gradient-text">Solutions</span></h2>
          <p className="lead text-muted mx-auto" style={{maxWidth:'800px'}}>From digital marketing to brand strategy, our tailored solutions are designed to meet the unique needs of each client. Our expertise spans across:</p>
        </div>

        <div className="row g-4">
          <div className="col-md-6 col-lg-4 scroll-reveal">
            <div className="service-card">
              <div className="service-icon-wrapper" aria-hidden="true">
                <div className="service-icon"><i className="bi bi-people"></i></div>
              </div>
              <h5 className="fw-bold">Social Media Management</h5>
              <p className="text-muted">Build and engage your community with strategic social media presence across all platforms.</p>
            </div>
          </div>

          <div className="col-md-6 col-lg-4 scroll-reveal">
            <div className="service-card">
              <div className="service-icon-wrapper" aria-hidden="true">
                <div className="service-icon"><i className="bi bi-pencil-square"></i></div>
              </div>
              <h5 className="fw-bold">Content Creation</h5>
              <p className="text-muted">Compelling content that tells your brand story and resonates with your target audience.</p>
            </div>
          </div>

          <div className="col-md-6 col-lg-4 scroll-reveal">
            <div className="service-card">
              <div className="service-icon-wrapper" aria-hidden="true">
                <div className="service-icon"><i className="bi bi-palette"></i></div>
              </div>
              <h5 className="fw-bold">Graphic Designing</h5>
              <p className="text-muted">Eye-catching visuals that capture attention and communicate your brand message effectively.</p>
            </div>
          </div>

          <div className="col-md-6 col-lg-4 scroll-reveal">
            <div className="service-card">
              <div className="service-icon-wrapper" aria-hidden="true">
                <div className="service-icon"><i className="bi bi-camera-video"></i></div>
              </div>
              <h5 className="fw-bold">Video Production</h5>
              <p className="text-muted">Professional video content that engages viewers and drives conversions.</p>
            </div>
          </div>

          <div className="col-md-6 col-lg-4 scroll-reveal">
            <div className="service-card">
              <div className="service-icon-wrapper" aria-hidden="true">
                <div className="service-icon"><i className="bi bi-person-badge"></i></div>
              </div>
              <h5 className="fw-bold">Influencer Marketing</h5>
              <p className="text-muted">Connect with your audience through authentic influencer partnerships and collaborations.</p>
            </div>
          </div>

          <div className="col-md-6 col-lg-4 scroll-reveal">
            <div className="service-card">
              <div className="service-icon-wrapper" aria-hidden="true">
                <div className="service-icon"><i className="bi bi-award"></i></div>
              </div>
              <h5 className="fw-bold">Brand Strategy</h5>
              <p className="text-muted">Develop a powerful brand identity that differentiates you in the marketplace.</p>
            </div>
          </div>

          <div className="col-md-6 col-lg-4 scroll-reveal">
            <div className="service-card">
              <div className="service-icon-wrapper" aria-hidden="true">
                <div className="service-icon"><i className="bi bi-badge-ad"></i></div>
              </div>
              <h5 className="fw-bold">Advertising Campaigns</h5>
              <p className="text-muted">Creative and impactful advertising campaigns that drive results and brand awareness.</p>
            </div>
          </div>

          <div className="col-md-6 col-lg-4 scroll-reveal">
            <div className="service-card">
              <div className="service-icon-wrapper" aria-hidden="true">
                <div className="service-icon"><i className="bi bi-calendar-event"></i></div>
              </div>
              <h5 className="fw-bold">Event Management</h5>
              <p className="text-muted">Seamless planning and execution of memorable brand experiences and events.</p>
            </div>
          </div>

          <div className="col-md-6 col-lg-4 scroll-reveal">
            <div className="service-card">
              <div className="service-icon-wrapper" aria-hidden="true">
                <div className="service-icon"><i className="bi bi-lightbulb"></i></div>
              </div>
              <h5 className="fw-bold">BTL Ideation</h5>
              <p className="text-muted">Creative below-the-line marketing strategies that create direct customer connections.</p>
            </div>
          </div>

          <div className="col-md-6 col-lg-4 scroll-reveal">
            <div className="service-card">
              <div className="service-icon-wrapper" aria-hidden="true">
                <div className="service-icon"><i className="bi bi-people-fill"></i></div>
              </div>
              <h5 className="fw-bold">Public Relations</h5>
              <p className="text-muted">Build and maintain a positive public image with strategic PR campaigns.</p>
            </div>
          </div>

          <div className="col-md-6 col-lg-4 scroll-reveal">
            <div className="service-card">
              <div className="service-icon-wrapper" aria-hidden="true">
                <div className="service-icon"><i className="bi bi-bar-chart"></i></div>
              </div>
              <h5 className="fw-bold">Media Planning and Buying</h5>
              <p className="text-muted">Strategic media placement to maximize reach and ROI across all channels.</p>
            </div>
          </div>

          <div className="col-md-6 col-lg-4 scroll-reveal">
            <div className="service-card">
              <div className="service-icon-wrapper" aria-hidden="true">
                <div className="service-icon"><i className="bi bi-bullseye"></i></div>
              </div>
              <h5 className="fw-bold">Experiential Marketing</h5>
              <p className="text-muted">Create immersive brand experiences that leave lasting impressions on your customers.</p>
            </div>
          </div>

          <div className="col-md-6 col-lg-4 scroll-reveal">
            <div className="service-card">
              <div className="service-icon-wrapper" aria-hidden="true">
                <div className="service-icon"><i className="bi bi-exclamation-triangle"></i></div>
              </div>
              <h5 className="fw-bold">Crisis Management</h5>
              <p className="text-muted">Protect your brand reputation with swift and strategic crisis response solutions.</p>
            </div>
          </div>

          <div className="col-md-6 col-lg-4 scroll-reveal">
            <div className="service-card">
              <div className="service-icon-wrapper" aria-hidden="true">
                <div className="service-icon"><i className="bi bi-search"></i></div>
              </div>
              <h5 className="fw-bold">Market Research</h5>
              <p className="text-muted">Data-driven insights to understand your market and make informed business decisions.</p>
            </div>
          </div>

          <div className="col-md-6 col-lg-4 scroll-reveal">
            <div className="service-card">
              <div className="service-icon-wrapper" aria-hidden="true">
                <div className="service-icon"><i className="bi bi-emoji-smile"></i></div>
              </div>
              <h5 className="fw-bold">Customer Experience Design</h5>
              <p className="text-muted">Design seamless customer journeys that delight at every touchpoint.</p>
            </div>
          </div>

          <div className="col-md-6 col-lg-4 scroll-reveal">
            <div className="service-card">
              <div className="service-icon-wrapper" aria-hidden="true">
                <div className="service-icon"><i className="bi bi-rocket"></i></div>
              </div>
              <div className="eyebrow text-uppercase small fw-semibold text-muted">Digital Transformation</div>
              <h5 className="fw-bold">Digital Transformation Consulting</h5>
              <p className="text-muted">Guide your business through digital transformation with expert consulting and strategy.</p>
            </div>
          </div>
        </div>
        <div className="section-divider mt-5"></div>
      </div>
    </section>
  );
}